import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { PROMO_APPLIED_EVENT } from '../lib/promo';

/**
 * PromoToast — "Pear Plus is on for your couple — thanks for using a promo code."
 *
 * Card KpYLZuhhlcvC: a promo code typed on the account-creation screen is
 * redeemed once the couple is formed, and the grant is a change in entitlement,
 * not a screen — so this toast is the one confirmation the person gets.
 *
 * Like ReferralToast, it shows ONLY on the event applyPendingPromo() dispatches
 * after a successful POST, never on a guess. Reuses the app's bottom-toast
 * recipe (.pear-update-toast) via a portal to body — a transformed ancestor is
 * the containing block for fixed positioning, so the portal keeps it pinned.
 */
export function PromoToast() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onApplied = () => setShow(true);
    window.addEventListener(PROMO_APPLIED_EVENT, onApplied);
    return () => window.removeEventListener(PROMO_APPLIED_EVENT, onApplied);
  }, []);

  if (!show) return null;

  return createPortal(
    <div className="pear-update-toast" role="status" data-testid="promo-toast">
      <span className="pear-update-toast-text">
        Pear Plus is on for your couple — thanks for using a promo code.
      </span>
      <button
        type="button"
        className="pear-update-toast-dismiss"
        aria-label="Dismiss promo notice"
        onClick={() => setShow(false)}
      >
        ✕
      </button>
    </div>,
    document.body,
  );
}